/**
 * Enum aller systemdefinierten Dashboard Widgets.
 * Wird als Identifier in Persistenz und Registry verwendet.
 */
export const WidgetType = Object.freeze({
    EigeneTodos: 'eigeneTodos',
    MitarbeiterTodos: 'mitarbeiterTodos',
    OffeneUrlaubsantraege: 'offeneUrlaubsantraege',
    Fristen: 'fristen',
    NeueMitteilungen: 'neueMitteilungen',
    AktiveMitarbeiter: 'aktiveMitarbeiter',
    Notizblock: 'notizblock',
    Firmenlogo: 'firmenlogo',
    LohnkostenBereich: 'lohnkostenBereich',
    LohnkostenTrend: 'lohnkostenTrend',
});

/**
 * Anzeige-Metadaten für jedes Widget. Wird im Add-Widget-Dialog verwendet.
 */
export const WidgetTypeMeta = Object.freeze({
    [WidgetType.EigeneTodos]: {
        name: 'Eigene Aufgaben',
        description: 'Persönliche Todoliste, gespeichert im Browser.',
        icon: 'bi-check2-square',
    },
    [WidgetType.MitarbeiterTodos]: {
        name: 'Mitarbeiter Aufgaben',
        description: 'Aufgaben eines ausgewählten Mitarbeiters einsehen und ergänzen.',
        icon: 'bi-clipboard-check',
    },
    [WidgetType.OffeneUrlaubsantraege]: {
        name: 'Offene Urlaubsanträge',
        description: 'Alle offenen Urlaubsanträge der Mitarbeiter im Überblick.',
        icon: 'bi-airplane-fill',
    },
    [WidgetType.Fristen]: {
        name: 'Fristen',
        description: 'Bevorstehende Fristen aller Mitarbeiter auf einen Blick.',
        icon: 'bi-hourglass-split',
    },
    [WidgetType.NeueMitteilungen]: {
        name: 'Neue Nachrichten',
        description: 'Mitarbeiter mit ungelesenen Nachrichten im Postfach.',
        icon: 'bi-envelope-fill',
    },
    [WidgetType.AktiveMitarbeiter]: {
        name: 'Aktive Mitarbeiter',
        description: 'Aktuell eingestempelte Mitarbeiter mit Bereich, Posten und Schichtdauer.',
        icon: 'bi-person-workspace',
    },
    [WidgetType.Notizblock]: {
        name: 'Notizblock',
        description: 'Persönlicher Notizblock, gespeichert im Browser.',
        icon: 'bi-sticky',
    },
    [WidgetType.Firmenlogo]: {
        name: 'Firmenlogo',
        description: 'Zeigt das hinterlegte Firmenlogo an.',
        icon: 'bi-image',
    },
    [WidgetType.LohnkostenBereich]: {
        name: 'Lohnkosten nach Bereich',
        description: 'Verteilung der monatlichen Lohnkosten je Bereich.',
        icon: 'bi-pie-chart-fill',
    },
    [WidgetType.LohnkostenTrend]: {
        name: 'Lohnkosten Trend',
        description: 'Täglicher Verlauf von geschätzten Sollkosten und Ist-Lohnkosten über den Monat.',
        icon: 'bi-graph-up',
    },
});
